export const scrollToTop = () => {
  document.body.scrollTop = document.documentElement.scrollTop = 0;
};

/** Scroll create-cluster / vertical-flow views to top (main app pane + document). */
export const scrollVerticalFlowToTop = (behavior: ScrollBehavior = "auto") => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;

  document
    .querySelectorAll<HTMLElement>("main div.overflow-y-auto, main .custom-scrollbar.overflow-y-auto")
    .forEach((element) => {
      element.scrollTo({ top: 0, behavior });
    });
};

export const getScrollableParent = (element: HTMLElement | null): HTMLElement | null => {
  let parent = element?.parentElement ?? null;

  while (parent) {
    const { overflowY } = window.getComputedStyle(parent);
    if (overflowY === "auto" || overflowY === "scroll") {
      return parent;
    }
    parent = parent.parentElement;
  }

  return null;
};
